import React, { Component } from "react";

class RangeMarker extends Component {
  render() {
    let max_value = this.props.maxValue;
    let min_value = this.props.minValue;
    let range_step = this.props.step;
    let marker_count = (max_value - min_value) / range_step;
    let width = Math.round((100 / marker_count) * 100) / 100;
    let range_array = [];
    for (var i = 0; i <= marker_count; i++) {
      range_array[i] = i * range_step;
    }

    return (
      <div className="range-marker">
        {range_array.map((count, step) => (
          <div
            key={step}
            style={{ left: width * step + "%" }}
            className={count === 0 || count === max_value ? "hide" : "marker"}
          >
            <div>
              <span>{count}</span>
            </div>
          </div>
        ))}
      </div>
    );
  }
}

export default RangeMarker;
